import React from "react";
import {PrimaryButton, SecondaryButton} from "components/Common";
import {useTranslation} from "react-i18next";
import {useBlockNavigation} from "modules/utils/hooks";
import {ButtonsBox, ModalIcon, ModalText, ModalTitle} from "components/Modals/common";
import {BaseModal} from "components/Modals/BaseModal";
import icon from "assets/images/icons/modalWarningIcon.svg";

interface ILeaveModal {
	isBlocking: boolean;
}

export const LeaveModal: React.FC<ILeaveModal> = ({isBlocking}) => {
	const {t} = useTranslation();
	const [showPrompt, confirmNavigation, cancelNavigation] = useBlockNavigation(isBlocking);

	if (!showPrompt || !isBlocking) {
		return null;
	}

	return (
		<BaseModal handleClose={cancelNavigation}>
			<ModalIcon className="small" src={icon} alt="Warning" />
			<ModalTitle>{t("modal.leave.title")}</ModalTitle>
			<ModalText>{t("modal.leave.desc")}</ModalText>
			<ButtonsBox>
				<SecondaryButton onClick={confirmNavigation}>
					{t("modal.leave.leave")}
				</SecondaryButton>
				<PrimaryButton onClick={cancelNavigation}>{t("modal.leave.stay")}</PrimaryButton>
			</ButtonsBox>
		</BaseModal>
	);
};
